import Vue from "vue";
import Vuex from "vuex";

import axios from "axios";

import { loader } from "./loader";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        dataRegister: [],
        status: null,
        token: localStorage.getItem("token"),
        flag_kyc: null,
        dataKyc: [],
        message: "",
        statusKyc: "",
        registerKYC: [],
        role: localStorage.getItem("role"),
        profils: localStorage.getItem("username"),
        status_login: null,
        loadingStatus: false,
        errMsgLogin: null,
        dataCustomer: "",
        imageUrl: "",
        geoData: "",
    },
    getters: {
        getDataRegister: (state) => {
            return state.dataRegister;
        },
        isAuthenticated(state) {
            return !!state.token;
        },

        flag_kyc: (state) => {
            return state.flag_kyc;
        },
        dataKYC: (state) => {
            return state.registerKYC;
        },

        profil: (state) => {
            return state.profils;
        },
        role: (state) => {
            return state.role;
        },

        status: (state) => {
            return state.status;
        },
        afterKyc: (state) => {
            return state.statusKyc;
        },
        getDataKyc: (state) => {
            return state.dataKyc;
        },
        loginLoading: (state) => {
            return state.loadingStatus;
        },
        loginStatus: (state) => {
            return state.status_login;
        },
        customerData(state) {
            return state.dataCustomer;
        },
    },
    actions: {
        getLocation({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(process.env.VUE_APP_GEO_URL)
                    // .get("https://asia-southeast1-jfx-kbi-prod.cloudfunctions.net/get-user-access-location")
                    .then((res) => {
                        resolve(res.data);
                        commit("setGeoData", res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getImageAccess({ commit }, url) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/v2/get/file" + url, { responseType: "arraybuffer" })
                    .then((res) => {
                        let data = `data:${res.headers["content-type"]};base64,${new Buffer(res.data, "binary").toString("base64")}`;
                        commit("dataImage", data);
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getVideo({ commit }, url) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/v2/get/file" + url)
                    .then((res) => {
                        // console.log(res);
                        // let data = `data:${res.headers["content-type"]};base64,${new Buffer(res.data, "binary").toString("base64")}`;
                        commit("dataImage", res);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getImageConfirmation({ commit }, { url, token }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/v2/internal/get" + url, {
                        responseType: "arraybuffer",
                        headers: {
                            "Content-type": "application/json",
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        let data = `data:${res.headers["content-type"]};base64,${new Buffer(res.data, "binary").toString("base64")}`;
                        commit("dataImage", data);
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getCustomer({ commit }) {
            return new Promise((resolve) => {
                axios({
                    url: "/v2/kyc/customer",
                    method: "GET",
                }).then((res) => {
                    let data = res.data.data.customer;
                    // localStorage.setItem("bank", data.bankType);
                    resolve(data);
                    commit("commitDataCustomer", data);
                });
            });
        },
        register({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit("auth_request");
                axios({
                    url: "/v2/user/register",
                    data: user,
                    method: "POST",
                })
                    .then((resp) => {
                        commit("REGISTER_SUCCESS", resp);
                        resolve(resp);
                    })
                    .catch((err) => {
                        commit("auth_error", err.response);
                        localStorage.removeItem("token");
                        reject(err);
                    });
            });
        },

        LOGIN({ commit }, userData) {
            return new Promise((resolve, reject) => {
                commit("LOGIN");
                commit("LoadingLogin", true);
                axios
                    .get("https://asia-southeast2-abi-kb-prod-297304.cloudfunctions.net/get-user-access-location")
                    // .get("https://asia-southeast1-abi-kb-dev-354604.cloudfunctions.net/get-user-access-location")
                    .then((res) => {
                        let latLong;
                        if (res.data.cityLatLong) {
                            latLong = res.data.cityLatLong.split(",");
                        } else {
                            latLong = ["", ""];
                        }
                        axios
                            .post("/v2/user/auth", userData, {
                                headers: {
                                    Latitude: latLong[0],
                                    Longitude: latLong[1],
                                    City: res.data.city,
                                    Region: res.data.region,
                                    Country: res.data.country,
                                    "IP-Address": res.data.userIP,
                                },
                            })
                            .then((response) => {
                                commit("LoginStatus", response.data.data);
                                commit("LoadingLogin", false);
                                const token = response.data.data.token;
                                localStorage.setItem("token", token);
                                axios.defaults.headers.common["Authorization"] = "Bearer " + token;
                                commit("AUTH_SUCCESS", response);
                                resolve(response);
                            })
                            .catch((error) => {
                                commit("LOGIN", error.response.status);
                                commit("LoadingLogin", false);
                                reject(error);
                            });
                    })
                    .catch((err) => {
                        reject(err);
                        commit("LOGIN", err.response);
                        commit("LoadingLogin", false);
                    });
            });
        },

        LoginGiro({ commit }, dataGiro) {
            return new Promise((resolve, reject) => {
                commit("loginGiro");
                axios
                    .post("/v1/user/kyc", dataGiro)
                    .then((rsp) => {
                        commit("loginGiro");
                        resolve(rsp);
                    })
                    .catch((err) => {
                        commit("loginGiro", err.response);
                        reject(err);
                    });
            });
        },

        KonfirmasiKtp({ commit }, ktp) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/v1/user/ektp", ktp)
                    .then((resp) => {
                        commit("ConvirmKtp", resp);
                        resolve(resp);
                    })
                    .catch((error) => {
                        commit("ConvirmKtp", error.response);
                        reject(error);
                    });
            });
        },

        REGISTER_KYC({ commit }, userData) {
            return new Promise((resolve, reject) => {
                axios({
                    url: "/v1/user/kyc",
                    data: userData,
                    method: "POST",
                })
                    .then((response) => {
                        resolve(response);
                        commit("DATA_KYC", response);
                    })
                    .catch((errors) => {
                        reject(errors);
                    });
            });
        },
        resetpassword({ commit }, data) {
            return new Promise((resolve, reject) => {
                commit("reset");
                axios({
                    url: "/v2/user/forgot",
                    data: data,
                    method: "POST",
                })
                    .then((response) => {
                        commit("reset");
                        resolve(response);
                    })
                    .catch((errors) => {
                        commit("reset", errors.response.status);
                        reject(errors);
                    });
            });
        },

        logout({ commit }) {
            return new Promise((resolve) => {
                commit("logout");
                localStorage.clear();
                delete axios.defaults.headers.common["Authorization"];
                resolve();
            });
        },

        getRegisterKYC({ commit }) {
            axios({
                url: "/v1/user/get/kyc",
                method: "GET",
            }).then((response) => {
                commit("dataRegisterKYC", response.data.data);
            });
        },

        getuser(context) {
            axios({
                url: "/v1/user/profile",
                method: "GET",
            }).then((resp) => {
                let profil = resp.data.data;
                context.commit("dataProfil", profil);
            });
        },
        Video_KYC(video_data) {
            axios({
                url: "/v1/user/upload/video_kyc",
                method: "PUT",
                data: video_data,
            }).then((resp) => {
                let profil = resp;
                console.log(profil);
            });
        },

        ubahProfil({ commit }, data) {
            return new Promise((resolve, reject) => {
                commit("changeProfil");
                axios({
                    method: "PUT",
                    url: "/v1/user/profile",
                    data: data,
                })
                    .then((response) => {
                        if (response.status == 200) {
                            this.$notify({
                                group: "profil",
                                title: "<h5>Berhasil</h5>",
                                type: "success",
                            });
                        }
                        commit("changeProfil", response.status);
                        resolve(response);
                    })
                    .catch((errors) => {
                        commit("changeProfil", errors);
                        reject(errors);
                    });
            });
        },

        // ubahPhotoProfil({commit}, data){
        //     return new Promise((resolve, reject) =>{
        //         commit('changeProfil')
        //         axios({
        //             url: '/v1/user/profile',
        //             data: data,
        //             method: 'PUT'
        //         })
        //         .then(response =>{
        //             console.log(response)
        //             commit('changeProfil')
        //             resolve(response)
        //         })
        //         .catch(errors =>{
        //             console.log(errors.response)
        //             commit('changeProfil', errors.response.status)
        //             reject(errors)
        //         })
        //     })
        // }
    },
    mutations: {
        setGeoData(state, payload) {
            state.geoData = payload;
        },
        dataImage(state, payload) {
            state.imageUrl = payload;
        },
        commitDataCustomer(state, customer) {
            state.dataCustomer = customer;
        },
        LoadingLogin(state, newStatus) {
            state.loadingStatus = newStatus;
        },

        LoginStatus(state, payload) {
            state.status_login = payload.status_code;
            state.errMsgLogin = payload.err_message;
        },
        addDataRegister(state, payload) {
            state.dataRegister.push(payload);
        },

        LOGIN(state, payload) {
            state.status = payload;
        },

        ConvirmKtp(state, payload) {
            state.status = payload.data.status;
        },

        AUTH_SUCCESS(state, token) {
            state.status_login = token.data.data.status_code;
            state.status = token.status;
            state.token = token;
        },

        REGISTER_SUCCESS(state, response) {
            state.dataToken = response.data.data;
            state.status = response.data.status;
            state.message = response.data.status;
        },

        DATA_KYC(state, payload) {
            state.status = "loading";
            state.registerKYC = payload.data.data;
        },

        auth_request(state) {
            state.status = "loading";
        },
        auth_error(state, payload) {
            state.message = payload.status;
        },

        logout(state) {
            state.status = "";
            state.token = "";
        },

        dataRegisterKYC(state, payload) {
            state.dataKyc = payload;
            state.statusKyc = payload.status;
        },

        dataProfil(state, payload) {
            state.profil = payload;
        },
        reset(state, data) {
            state.status = data;
        },
        loginGiro(state, payload) {
            state.status = payload;
        },
        changeProfil(state, data) {
            state.message = data;
        },
    },
    modules: {
        loader,
    },
});
